import axios from 'axios';
import { StoreApi } from 'zustand';

import {
  getShopifyAxiosConfig,
  getShopifyGqlEndpoint,
  getShopifyUrlAndToken,
} from '../../shopify';
import { CustomerStore } from './useCustomer';

const query = `
query customer($token: String!) {
  customer(customerAccessToken: $token) {
    id
    createdAt
    updatedAt
    displayName
    firstName
    lastName
    phone
    email
    tags
    defaultAddress { 
      company
    }

    # https://shopify.dev/api/storefront/2022-01/objects/MailingAddress#fields
    defaultAddress {
      address1
      address2
      city
      country
      company
      zip
    }
    
    # https://shopify.dev/api/storefront/2022-01/objects/Checkout#fields
    # lastIncompleteCheckout {}
  }
}`;

export function fetchCustomer(
  set: StoreApi<CustomerStore>['setState'],
  get: StoreApi<CustomerStore>['getState'],
): () => Promise<void> {
  return async () => {
    try {
      const { token } = getShopifyUrlAndToken();
      const accessToken = get().customerAccessToken?.accessToken;

      if (!accessToken) {
        return;
      }

      const customerRequest = await axios.post(
        getShopifyGqlEndpoint(),
        {
          query,
          variables: { token: accessToken },
        },
        getShopifyAxiosConfig(token),
      );

      const customer = customerRequest?.data?.data?.customer;

      if (!customer) {
        return;
      }

      set({ customer });
    } catch (err) {
      console.error(err);
    }
  };
}
